import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";

import { CustomerRoute, OnboardingRoute } from "helper/route";
import LayoutContainer from "containers/Layout";

// pages
import JarvisPrimeOnboardingNavigator from "./JarvisPrimeOnboardingNavigator";
import PrimeDashboard from "pages/JarvisPrime/PrimeDashboard";
import PrimeActionCentre from "pages/JarvisPrime/PrimeActionCentre";
import PrimeInvestMore from "pages/JarvisPrime/PrimeInvestMore";
import PrimeStartSIP from "pages/JarvisPrime/PrimeStartSIP";
import PrimeTransaction from "pages/JarvisPrime/PrimeTransaction";
import PrimeExistingHolding from "pages/JarvisPrime/PrimeExistingHolding";

const JarvisPrimeNavigator = (props) => {
  const { match } = props;
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );

  // Product onboaridng completed
  const isPortfolioOnboardingCompleted = useSelector(
    (state) => state.onboarding.isOnboardingCompleted
  );
  const isRMSonboardingCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isOnboardingCompleted
  );
  const isOnestockonboardingCompleted = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted
  );
  const isPrimeOnboardingComplete = useSelector(
    (state) => state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted
  );
  const isSentimentTrackerOnboardingCompleted = useSelector(
    (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted
  );

  const isPhcOnboardingCompleted = useSelector(
    (state) => state.PHC.PHCOnboarding.isOnboardingCompleted
  );

  const anyOnboardingCompleted =
    isPortfolioOnboardingCompleted ||
    isRMSonboardingCompleted ||
    isOnestockonboardingCompleted ||
    isPrimeOnboardingComplete ||
    isSentimentTrackerOnboardingCompleted ||
    isPhcOnboardingCompleted;

  const redirectTo = () => {
    let restPath = "dashboard";
    if (!isPrimeOnboardingComplete) {
      restPath = "onboarding";
    }
    return `${match.path}/${restPath}`;
  };

  return (
    <Switch>
      {/* 1 - Redirection to */}
      <Redirect exact from={match.path} to={redirectTo()} />

      {/* 2 -  Child Navigator */}
      <OnboardingRoute
        isAuthenticated={isAuthenticated}
        isOnboardingCompleted={isPrimeOnboardingComplete}
        // redirectOnboardingIncomplete={`${match.path}/dashboard`} // old code to redirect if any onboarding completed  
        redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
        path={`${match.path}/onboarding`}
        component={JarvisPrimeOnboardingNavigator}
      />

      {/* 3 - With layout pages */}
      <LayoutContainer {...props}>
        <Switch>
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/dashboard`}
            component={PrimeDashboard}
          />

          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/action-centre`}
            component={PrimeActionCentre}
          />

          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/invest-more`}
            component={PrimeInvestMore}
          />

          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/start-sip`}
            component={PrimeStartSIP}
          />

          <CustomerRoute
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/transactions`}
            component={PrimeTransaction}
          />
          <CustomerRoute
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/existing-holding`}
            component={PrimeExistingHolding}
          />
        </Switch>
      </LayoutContainer>
      <Redirect to={`not-found`} />
    </Switch>
  );
};

export default JarvisPrimeNavigator;
